export const formatDateTime = (date: Date, options?: Intl.DateTimeFormatOptions): string => {

    let defaultOptions: Intl.DateTimeFormatOptions;
    defaultOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
    } as Intl.DateTimeFormatOptions;

    return new Intl.DateTimeFormat("ru-RU", options ?? defaultOptions).format(date)
}
